export { RatePlanLegalText } from './RatePlanLegalText';
export { RatePlanVasLegalText } from './RatePlanVasLegalText';
export { CartLegalText } from './CartLegalText';
export { GiftLegalText } from './GiftLegalText';
